import React, { useState } from 'react';
import Modal from "react-modal";

import Megaphone from '../assets/megaphone-outline.svg';
import SolFundLogo from '../assets/solfund_logo.svg';

import '../css/home.css';

import NFT from './NFT';
import Footer from './Footer';

function Home() {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [isWalletConnected, setIsWalletConnected] = useState(true);
    const [inputs, setInputs] = useState({});

    function toggleFormModal() {
        console.log('form')
        setIsFormOpen(!isFormOpen);
    }
    const onFormSubmit = (e) => {
        e.preventDefault();
        console.log(inputs);
        // do whatever you want to do with the form inputs using inputs
        toggleFormModal();
    }
    const onFormChange = (inputId, inputValue) => {
        // console.log(inputId, inputValue);
        setInputs(values => ({...values, [inputId]: inputValue}));
        setIsWalletConnected(false);
    }

    return (
        <React.Fragment>
            <div id='linear-gradient'></div>
            <div className="body">
                {isWalletConnected && 
                    <section id="hero" className='flex-container vertical center'>
                        <div className="inner-hero">
                            <h2 className="heading">Become an Accredited Investor Today</h2>
                            <p className='hero-info'>We make it easy by providing you with an Accredited Investor Token for you to hold in your wallet. With it, you’ll finally be able to participate in any Web 3 investment opportunities that require accredited investor certification.</p>
                            <button className='get-started' onClick={toggleFormModal}>Get started</button>
                        </div>
                    </section>
                }
                {!isWalletConnected && 
                    <section id="hero" className='flex-container vertical right'>
                        <div className="inner-hero">
                            <h2 className="heading">Become an Accredited Investor Today</h2>
                            <p className='hero-info'>We make it easy by providing you with an Accredited Investor Token for you to hold in your wallet. With it, you’ll finally be able to participate in any Web 3 investment opportunities that require accredited investor certification.</p>
                            <button className='get-started' onClick={toggleFormModal}>Get started</button>
                        </div>
                    </section>
                }
                <section id="steps">
                    <div className="flex-container around">
                        <div className="card">
                            <div className="step">
                                <h3 className="sub-title">Step 1</h3>
                                <p className="content">Fill out our short 1 question form to see if you qualify</p>
                            </div>
                        </div>
                        <div className="card">
                            <div className="step">
                                <h3 className="sub-title">Step 2</h3>
                                <p className="content">Connect your wallet & pay a small fee of 2 SOL</p>
                            </div>
                        </div>
                        <div className="card">
                            <div className="step">
                                <h3 className="sub-title">Step 3</h3>
                                <p className="content">Receive your accredited Investor Token NFT!</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="body-content">
                    <div className="info flex-container center">
                        <div className="announcement-card flex-container horizontal">
                            <img className='megaphone' src={Megaphone} alt="Megaphone outline" />
                            <p className="content">
                            We’ll announce more partnerships as we form them, but our goal is to be the accredited investor token across all chains, not just every Solana project!
                            </p>
                        </div>
                    </div>
                    <div className="flex-container center token">
                        <h3 className="green-large">Tokens required for these opportunities:</h3>
                        <div className="card token">
                            <div className="flex-container center token left step">
                                <img className='token-logo' src={SolFundLogo} alt='logo for sol fund token' />
                                <p className='token-content'>$SOL Fund 001 is the first of its kind Web 3 fund, raising $SOL through an NFT sale, holding and then investing $SOL in Solana-based projects and companies.</p>
                                <button className='website-link-btn'>View Website</button>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="form-btn">
                    <div className="flex-container center">
                        <button className='get-started' onClick={toggleFormModal}>Get started</button>
                    </div>
                </section>
            </div>
            <Modal
                isOpen={isFormOpen}
                onRequestClose={toggleFormModal}
                contentLabel="Connect Wallet"
                className="base-modal nft-form-modal nft-form"
                overlayClassName="base-overlay"
                ariaHideApp={false}
            >
                <NFT onChange={onFormChange} onSubmit={onFormSubmit} />
            </Modal>
            <Footer />
        </React.Fragment>
    );
}

export default Home;
